// removes all lines from the end of a text that contain only hashtags
export const removeHashtagLines = (text: string): string => {
  const lines = text.split('\n');
  while (lines[lines.length - 1]?.trim().match(/^(#[\p{L}\p{N}]+)( #[\p{L}\p{N}]+)*$/u)) {
    lines.pop();
  }
  return lines.join('\n') || ' ';
};
